var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84672 8.00067L10.6867 6.16067C10.9187 5.92867 10.9187 5.54467 10.6867 5.31267C10.4547 5.08067 10.0707 5.08067 9.83872 5.31267L7.99872 7.15267L6.15872 5.31267C5.92672 5.08067 5.54272 5.08067 5.31072 5.31267C5.07872 5.54467 5.07872 5.92867 5.31072 6.16067L7.15072 8.00067L5.31072 9.84067C5.07872 10.0727 5.07872 10.4567 5.31072 10.6887C5.43072 10.8087 5.58272 10.8647 5.73472 10.8647C5.88672 10.8647 6.03872 10.8087 6.15872 10.6887L7.99872 8.84867L9.83872 10.6887C9.95872 10.8087 10.1107 10.8647 10.2627 10.8647C10.4147 10.8647 10.5667 10.8087 10.6867 10.6887C10.9187 10.4567 10.9187 10.0727 10.6867 9.84067L8.84672 8.00067Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDark);
export default __webpack_public_path__ + "static/media/close_dark.e8ee5b49a27e8eb8cfd3cd92af1447e3.svg";
export { ForwardRef as ReactComponent };